import Head from "next/head";
import { useOnboardingFlowVariation } from "@medbillai/app/lib/onboarding/useOnboardingFlowVariation";
import { GetStartedScreen } from "@medbillai/app/screens/auth/get-started/get-started";
import { OnboardingShell } from "@medbillai/app/screens/onboarding";
import { SignUpOnboardingLayout } from "@medbillai/app/screens/sign-up-onboarding/layout.web";
import { OnboardingPageTransition } from "../utils/transition/OnboardingPageTransition";
import { SlidingLayout } from "../utils/transition/SlidingLayout";
import type { NextPageWithLayout } from "./_app";
export const Page: NextPageWithLayout = () => {
  const onboardingVersion = useOnboardingFlowVariation();
  return <>
      <Head data-sentry-element="Head" data-sentry-source-file="get-started.tsx">
        <title>Get Started</title>
      </Head>
      {onboardingVersion === "v2.0" ? <OnboardingShell phase="preauth" Transition={OnboardingPageTransition} /> : <GetStartedScreen />}
    </>;
};
Page.getLayout = page => <SignUpOnboardingLayout>
    <SlidingLayout>{page}</SlidingLayout>
  </SignUpOnboardingLayout>;
export default Page;